import { CourseModuleFrame } from '@/components/courses/CourseModuleFrame';
import { QuizFeedback } from '@/components/quiz/QuizFeedback';
import React from 'react';

type CourseFeedbackModuleProps = React.ComponentProps<typeof QuizFeedback> & {
  accessibilityIcon?: React.ReactNode;
};

export const CourseFeedbackModule: React.FC<CourseFeedbackModuleProps> = ({
  accessibilityIcon,
  ...feedbackProps
}) => (
  <CourseModuleFrame>
    {accessibilityIcon}
    <QuizFeedback {...feedbackProps} />
  </CourseModuleFrame>
);
